import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, NgForm, NgModel } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

import { AuthService } from '../../../../core/auth/auth.service';
import { FormFieldErrorComponent } from '../../../../shared/components/form-field-error/form-field-error.component';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, AuthLayoutComponent, FormFieldErrorComponent],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  email = '';
  password = '';
  isLoading = false;
  passwordVisible = false;
  message = '';
  isError = false;

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  constructor(private authService: AuthService, private router: Router) {}

  async onLogin(form: NgForm): Promise<void> {
    if (form.invalid) {
      this.message = 'Please fill in all required fields.';
      this.isError = true;
      return;
    }

    this.isLoading = true;
    try {
      await this.authService.login(this.email, this.password);
      this.router.navigate(['/app/dashboard']);
    } catch (error: any) {
      this.message = error.message || 'Invalid credentials';
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Clears error message when user focuses on email or password field
   */
  onFieldFocus(): void {
    this.message = '';
    this.isError = false;
  }

  getErrors(control: NgModel): string[] {
    if (!control.invalid || !control.errors || (!control.dirty && !control.touched)) {
      return [];
    }

    const errors: string[] = [];
    if (control.errors['required']) {
      errors.push('This field is required.');
    }
    if (control.errors['email']) {
      errors.push('Please enter a valid email address.');
    }
    // Add more error types as needed
    return errors;
  }
}
